<template>
  <b-container fluid class="view-full">
    <b-breadcrumb :items="breadcrumbItems" class="minus-gutters"></b-breadcrumb>
    <b-row class="subscription-group" align-v="center">
      <b-col cols="auto" class="mr-auto subscription-btn">
        <template v-for="(item,index) in checked">
          <b-button variant="light" :key="index" @click="removeCrop(item)">{{item.C_NAME}}<b-icon icon="x-circle" aria-hidden="true" class="ml-2"></b-icon></b-button>
        </template>
      </b-col>
      <b-col cols="auto">
        <b-button @click="saveprocess" variant="primary">儲存變更</b-button>
      </b-col>
    </b-row>
    <b-alert
      :show="messageObject.warning.count"
      variant="danger"
      dismissible
      @dismissed="messageObject.warning.count = 0"
      @dismiss-count-down="warningCountChanged"
      >{{ messageObject.warning.content }}
    </b-alert>
    <b-row align-h="center">
      <b-col md="5" class="setdivheight">
        <!--email訂閱功能先關閉，之後需要在打開 -->
        <!-- <b-row>
          <h3 style="margin-right: 0.5rem;">Email 訂閱</h3>
          <b-form-checkbox
            v-model="account.AC_NOTIFY"
            name="check-button"
            switch
            size="lg"
            value="true"
            unchecked-value="false"
          >
          </b-form-checkbox>
        </b-row> -->
        <b-row>
          <span
            >指定農情作物<br /><I style="font-size:0.8rem"
              >最多選取五項作物</I
            ></span
          >
        </b-row>
        <!-- <b-row style="margin-bottom: 0.5rem;">
          <span
            ><I style="font-size:0.8rem"
              >※由於某些信箱會有阻擋廣告信的功能，請到您的垃圾信件匣查看，並勾選「嘉義縣農情資訊平台
              」信件，點選非垃圾郵件的按鍵。</I
            ></span
          >
        </b-row> -->
        <b-row
          style="display: flex;justify-content: center; align-items: center; margin-bottom: 1.5rem;"
        >
          
        </b-row>
        <b-container>
          <b-row style="margin-bottom: 0.5rem;" >
            <b-col>
              <b-button class="white-text-btn blue" @click="changeCategory(0)"
                >水果類</b-button
              >
              <b-button class="white-text-btn orange" @click="changeCategory(1)"
                >根莖菜類</b-button
              >
              <b-button class="white-text-btn green" @click="changeCategory(2)"
                >葉菜類</b-button
              >
              <b-button class="white-text-btn purple" @click="changeCategory(3)"
                >花果菜類</b-button
              >
              <b-button class="white-text-btn darkblue" @click="changeCategory(4)"
                >菇菌類</b-button
              >
              <b-button class="white-text-btn yellow" @click="changeCategory(5)"
                >五穀雜糧類</b-button
              >
              <b-button class="white-text-btn brown" @click="changeCategory(6)"
                >其他類</b-button
              >
              <b-form-input
                class="farminput"
                v-model="crop.filter"
                placeholder="請輸入作物關鍵字查詢"
                debounce="500"
                max="10"
              ></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="3" v-for="(item, index) in subscriptionList" :key="index">
              <label class="choose-box box">
                <b-checkbox
                  v-model="checked"
                  :value="item"
                  class="d-inline"
                ></b-checkbox>
                {{ item.C_NAME }}
              </label>
            </b-col>
          </b-row>
        </b-container>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import SUBSCRIPTION from "@/data/SUBSCRIPTION_CODE_LIST.json";

export default {
  data() {
    return {
      PassToken: this.$route.query.Token,
      checked: [],
      indeterminate:null,
      old_checked: [],
      subscriptionSelected:{ code: null, label: '請選擇' },
      breadcrumbItems: [
        {
          text: "首頁",
          href: "#",
        },
        {
          text: "訂閱",
          active: true,
        },
      ],
      crop:{
        filter:null,
        fruitList:[],
        rhizomeList:[],
        leafyList:[],
        FlowerFruitList:[],
        MushroomList:[],
        WholeGrainsList:[],
        otherList:[]
      },
      cropList:[],
      selectList:[],
      subscriptionList:[],
      subscriptionOldList:[],
      subscriptionSelectList:[{ code: '0', label: '請選擇' }],
      subscription: SUBSCRIPTION,
      subscription2:[],
      passwordobject: {
        first: {
          value: null,
          state: null,
          message: "欄位不能為空值",
        },
        second: {
          value: null,
          state: null,
          message: "欄位不能為空值",
        },
      },
      account: {
        AC_TEL: null,
        AC_TITLE: null,
        AC_CONTENT: null,
        AC_NOTIFY: "false",
      },
      messageObject: {
        warning: {
          show: false,
          content: null,
          count: 0,
        },
        dismissSecs: 3,
      },
      savelist: [],
      apiCropSubscribeList: (data) =>
        this.userRequest.post("API/Default/CropSubscribeList", data),
      apiCropSubscribeUpdate: (data) =>
        this.userRequest.post("API/Default/CropSubscribeUpdate", data),
      apiGetAccountSelf: (data) =>
        this.userRequest.post("API/Default/GetAccountSelf", data),
      apiGetthisAccount: (data) =>
        this.userRequest.post("API/Default/GetthisAccount", data),
      apiUpdateAccountSelf: (data) =>
        this.userRequest.post("API/Default/UpdateAccountSelf", data),
      apiCropDescriptionList: (data) =>
        this.userRequest.post("API/Default/CropDescriptionList",data),
    };
  },
  created() {
    this.checkLogin();
    
  },
  watch:{
    "subscriptionSelected"(){
      // if(val == null) this.subscriptionSelected ={ code: '0', label: '請選擇' };
      // if(val.code != '0'){
      //   this.subscriptionList = this.subscription2.filter( x =>x.C_ID == val.code);
      // }
      // else{
      //   this.subscriptionList = this.subscription2;
      // }
    },
    "crop.filter"(val){
      if(val != null) {
        this.subscriptionList = this.subscriptionOldList.filter((x) => x.C_NAME.includes(val));
      }
    },
    "checked"(){
      if(this.checked.length >5){
        alert("最多只能選取五項")
        setTimeout(()=>{
          this.checked.pop();
        }, 100);
        
      }
    }
  },
  methods: {
    checkLogin() {
        let TokenID = sessionStorage.getItem("TokenID");
        if (TokenID) {
        this.init();
        } else {
        alert("未有權限檢視此頁面，請登入帳號");
        this.$router.push({ path: "/login" });
        }
    },
    //訂閱清單總列表
    getCropDescriptionList(data){
      this.apiCropDescriptionList(data)
        .then((res) =>{
          const json = JSON.parse(res.data);
          if(json.Status){
            const jsondata = JSON.parse(json.Data);
            //console.log(jsondata)
            for(var item in jsondata){
              let obj ={
                C_ID: jsondata[item].C_ID,
                C_NAME : jsondata[item].V_COMMON,
                C_NUMBER: jsondata[item].number
              }
              if(jsondata[item].V_TYPE == "水果類") this.crop.fruitList.push(obj);
              else if(jsondata[item].V_TYPE == "根莖菜類")this.crop.rhizomeList.push(obj);
              else if(jsondata[item].V_TYPE == "葉菜類")this.crop.leafyList.push(obj);
              else if(jsondata[item].V_TYPE == "花果菜類")this.crop.FlowerFruitList.push(obj);
              else if(jsondata[item].V_TYPE == "五穀雜糧類")this.crop.WholeGrainsList.push(obj);
              else if(jsondata[item].V_TYPE == "其他類")this.crop.otherList.push(obj);
              else this.crop.MushroomList.push(obj);
              
              this.subscriptionList.push(obj);
            }
            this.subscriptionOldList = this.subscriptionList;
            //this.subscriptionList = this.subscription2;
            //console.log("this.subscriptionSelectList",this.subscriptionSelectList)
          }
        })
    },
    // 取得使用者訂閱清單
    getCropSubscribeList(data) {
      this.apiCropSubscribeList(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            let list = JSON.parse(json.Data);
            if (list.length > 0) {
              list.forEach((x) => {
                let obj = {
                  C_ID: x.C_ID,
                  C_NAME: x.C_NAME,
                  C_NUMBER: x.C_NUMBER
                };
                this.checked.push(obj);
              });
            }
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    updateCropSubscribe(data) {
      this.apiCropSubscribeUpdate(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            alert("儲存成功");
            this.$router.push({ path: "/myprefecture" });
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    getAccountSelf(data) {
      //this.apiGetAccountSelf(data)
      this.apiGetthisAccount(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            let item = JSON.parse(json.Data);
            this.account = {
              AC_USERNAME: item.AC_USERNAME,
              AC_TEL: item.AC_TEL,
              AC_TITLE: item.AC_TITLE,
              AC_CONTENT: item.AC_CONTENT,
              AC_NOTIFY: "false",//email訂閱功能先關閉 
            };
            this.FunctionToken(this.getCropSubscribeList, {});
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    updateAccountSelf(data) {
      this.apiUpdateAccountSelf(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            this.FunctionToken(this.updateCropSubscribe, {
              Crops: this.checked,
            });
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    changeCategory(val){
      
      if(val == 0) this.subscriptionList = this.crop.fruitList;
      else if(val == 1) this.subscriptionList = this.crop.rhizomeList;
      else if(val == 2) this.subscriptionList = this.crop.leafyList;
      else if(val == 3) this.subscriptionList = this. crop.FlowerFruitList;
      else if(val == 4)this.subscriptionList = this.crop.MushroomList;
      else if(val == 5)this.subscriptionList = this.crop.WholeGrainsList;
      else this.subscriptionList = this.crop.otherList;
      //console.log("this.subscriptionList",this.subscriptionList)
    },
    init() {
      this.FunctionToken(this.getAccountSelf, {});
      this.FunctionToken(this.getCropDescriptionList,{});
    },
    removeCrop(data){
      let index = this.checked.findIndex(x=> x.C_ID==data.C_ID && x.C_NAME==data.C_NAME && x.C_NUMBER == data.C_NUMBER);
      if(index != -1){
        this.checked.splice(index,1);
      }
    },
    saveprocess() {
      if (this.checked.length > 5) {
        alert("選擇的作物不能超過5個");
      }else if(this.checked.length == 0){
        alert("請選擇至少一種作物");
      }
      else {
        this.FunctionToken(this.updateAccountSelf, this.account);
      }
    },
    warningPopUp(msg) {
      this.messageObject.warning.count = this.messageObject.dismissSecs;
      this.messageObject.warning.content = msg;
    },
    warningCountChanged(count) {
      this.messageObject.warning.count = count;
    },
  },
};
</script>

<style scoped>
/* The choose-box */
.choose-box {
  display: block;
  position: relative;
  margin-bottom: 12px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.choose-box.box {
  border: 1px solid #e6e6e6;
}

/* Hide the browser's default checkbox */
.choose-box input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #e6e6e6;
}

/* On mouse-over, add a grey background color */
.choose-box:hover input ~ .checkmark {
  background-color: #e7f1ee;
}

/* When the checkbox is checked, add a blue background */
.choose-box input:checked ~ .checkmark {
  background-color: #fefefe;
  background-color: #e7f1ee;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.choose-box input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.choose-box .checkmark:after {
  left: 11px;
  top: 7px;
  width: 5px;
  height: 10px;
  border: solid #60a08b;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
/* Style white-text-btn */
.white-text-btn {
  color: rgb(255, 255, 255);
  margin-right: 0.1em;
  border: none !important;
  display: inline-block;

  &.blue {
    background-color: rgb(22, 155, 213);
  }

  &.orange {
    background-color: rgb(234, 123, 13);
  }

  &.green {
    background-color: rgb(112, 182, 3);
  }

  &.purple {
    background-color: rgb(194, 128, 255);
  }

  &.darkblue{
    background-color: rgb(74, 91, 217);
  }

  &.yellow{
    background-color: rgb(233, 210, 37);
  }

  &.brown{
    background-color: rgb(164, 109, 38);
  }
}

.farminput {
  margin-top: 0.5rem;
  max-width: 13rem;
  display: inline-block;
}
</style>
